import React , { useEffect }  from "react";
import { useNavigate } from "react-router-dom";
import SearchBox from "./searchbox";
import Button from "@mui/material/Button";
import { Box, Container } from "@mui/material";
import AdminImg from "../images/admin.png";
import Layout from "../components/layout";

function Dashboard() {
  const navigate = useNavigate();
  const role = localStorage.getItem('roleID');
  
  // Get user data for role checking
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const rawRole = (
    user?.role || user?.role_name || user?.roleName || localStorage.getItem('roleName') || ''
  ).toString().trim();
  const normalizedRole = rawRole
    .toUpperCase()
    .replace(/\s+/g, '_')
    .replace(/-/g, '_');
  const isSuperAdmin =
    normalizedRole === "SUPER_ADMIN" ||
    normalizedRole === "SUPER_USER" ||
    normalizedRole === "SUPERUSER";

// Signin added Tejashwini

// useEffect(() => {
//   const token = localStorage.getItem('token');
//   console.log("Token found:", token); // Debugging line
//   if (!token) {
//       navigate('/dashboard'); // Redirect to sign-in if no token found
//   }
// }, [navigate]);


  const studentNavigation = () => {
    navigate("/student-management");
  };

  const userManagement = () => {
    navigate("/user-management");
  };

  const feesManagementNavigation = () => {
    navigate("/fees-management");
  };
  
  const erpManagementNavigation = () => {
    navigate("/erp-management");
  };

  return (
    //Simran
   
    <Container>

      <Layout />

      <div style={{  
  justifyContent: 'flex-end', position:'sticky'
   
  
      }}>
       <SearchBox  />
      <Box className="container-box"
      // sx={{ flex: 1, display: 'flex', alignSelf:'flex-end' }}
      >
        <Box 
        sx={{  display: 'flex', flexDirection: 'flex-start', marginBottom:'0', padding:'0',marginLeft:'80px' }}
        >
          <img
            src={AdminImg}
            alt="Dummy" className="image-style"
            // style={{ width: '100%', height: '65vh' }}

          />
        </Box>
        <Box 
        sx={{ flex: 1,display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft:'0' }}
        >
          <Button
            onClick={userManagement}
            // style={{ width: '55%', backgroundColor:"#0A64A2",marginTop: '2rem', fontSize:'1.1rem', letterSpacing:'2px', height: '11vh' }}
            className="button-style" variant="contained"
            size="large"
          >
            <b>User Management</b>
          </Button>
          <Button
            // style={{ width: '55%',backgroundColor:"#0A64A2", marginTop: '2rem', fontSize:'1.1rem', letterSpacing:'2px', height: '11vh' }}
            className="button-style" onClick={studentNavigation}
            variant="contained"
            size="large"
          >
            <b>Student Management</b>
          </Button>
          <Button
            // style={{ width: '55%',backgroundColor:"#0A64A2", marginTop: '2rem', fontSize:'1.1rem', letterSpacing:'2px', height: '11vh' }}
            className="button-style" onClick={feesManagementNavigation}
            variant="contained"
            size="large"
            disabled={role === "4" || role === "16"}
          >
            <b>Fees Management</b>
          </Button>
          <Button
            // style={{ width: '55%',backgroundColor:"#0A64A2", marginTop: '2rem', fontSize:'1.1rem', letterSpacing:'2px', height: '11vh' }}
           onClick={erpManagementNavigation}
           className="button-style"
            variant="contained"
            size="large"
            disabled={role === "4" || role === "16"}
          > 
          {/* changed caption to 'ERP' */}
            <b>ERP</b>
            {/* End */}
          </Button>
        </Box>
      </Box> 
      </div>

    </Container>
  );
}

export default Dashboard;
